import { getRegion, paymentOptions, deliveryOptions } from '@global/gtm/base';

export default class CartGTM {
  constructor() {
    this.region = getRegion();

    this.paymentOptions = paymentOptions;

    this.deliveryOptions = deliveryOptions;
  }

  getUserSelect(payload) {
    const {
      coupon,
      pPoint,
      faPoint,
      countryCode,
      provinceCode,
      payTypeCode,
      deliveryCode,
      cvsCode,
      cvsName,
      cvsAddress,
    } = payload;

    const couponType = `電子折價券代碼:${coupon}`;
    const country = this.region.regions.find((region) => region.value === countryCode).name;

    let area = '';
    if (countryCode === 17) {
      area = this.region.provinces.find((province) => province.value === provinceCode).name;
    }

    const payType = this.paymentOptions[payTypeCode];
    const shipping = this.deliveryOptions[deliveryCode];

    let store = '';

    if (deliveryCode === 2 || deliveryCode === 7) {
      store = `${cvsCode} ${cvsName} ${cvsAddress}`;
    }

    return {
      area,
      couponType,
      country,
      faPoint,
      payType,
      pPoint,
      shipping,
      store,
    };
  }

  /**
   * Retrieves the product price from the given memo object.
   *
   * @param {object} memo - The memo object containing the product details.
   * @return {object} An object containing the total price, shipping fee, and pay price.
   */
  static getProductPrice(memo) {
    const totalPrice = memo.TotalPrice;
    const shippingFee = Number(memo.ShippingCost);
    const payPrice = memo.PayPrice;

    return {
      totalPrice,
      shippingFee,
      payPrice,
    };
  }

  static transformProductInfo(payload) {
    const { basket, shoppingData, addonData, gitData } = payload;
    const itemCategory = JSON.parse(localStorage.getItem('ECDataLayer')) || null;
    const checkoutCartType = basket % 2 !== 0 ? '現貨' : '預購';
    const tempDataLayer = [];
    const categoriesName = [
      'item_category',
      'item_category2',
      'item_category3',
      'item_category4',
      'item_category5',
    ];

    const addonItems = addonData.map((curr) => ({
      promotionId: String(curr.ID),
      promotionName: curr.Name,
      items: curr.Items,
      category: '加價購商品',
    }));

    const giftItems = gitData.map((curr) => ({
      promotionId: curr.ID,
      promotionName: curr.Name,
      items: curr.Gifts,
      category: '贈品',
    }));

    const combineData = [...addonItems, ...giftItems];

    shoppingData.forEach((element, index) => {
      const item = {
        affiliation: element.ColorName || '',
        coupon: element.Coupons.length ? element.Coupons[0].Code : '',
        index,
        item_brand: element.Size || '',
        item_id: element.CustomMarketID.split('SZ')[0] || '',
        item_list_name: `${checkoutCartType} 購物車清單`,
        item_name: element.Name || '',
        item_variant: element.BarCode || '',
        price: element.SellPrice || undefined,
        promotion_id: element.Events.length ? String(element.Events[0].ID) : '',
        promotion_name: element.Events.length ? element.Events[0].Name : '',
        quantity: element.Count || undefined,
      };

      if (itemCategory) {
        const addItemCategory = itemCategory.find((v) => {
          return v.customMarketID === element.CustomMarketID.split('SZ')[0];
        });

        if (addItemCategory && addItemCategory.itemCategory.length !== 0) {
          addItemCategory.itemCategory.forEach((category, categoryIndex) => {
            item[categoriesName[categoryIndex]] = category;
          });
        }
      }

      tempDataLayer.push(item);
    });

    let shoppingDataLength = shoppingData.length;

    combineData.forEach((element) => {
      element.items.forEach((item) => {
        const itemObject = {
          affiliation: item.ColorName || '', // 顏色(廠商弄錯的)
          index: shoppingDataLength,
          item_brand: item.Size || '',
          item_id: item.CustomMarketID.split('SZ')[0] || '',
          item_list_name: `${checkoutCartType} 購物車清單`,
          item_name: item.Name || '',
          item_variant: item.BarCode || '',
          price: item.SellPrice || undefined,
          quantity: item.Count || undefined,
          promotion_id: element.promotionId || '',
          promotion_name: element.promotionName || '',
          item_category: element.category,
        };

        ++shoppingDataLength;

        tempDataLayer.push(itemObject);
      });
    });

    return tempDataLayer;
  }

  static setDataToLocalStorage(userData) {
    const { getUserSelect, productPriceInfo, transformProductInfo } = userData;

    const checkoutInfo = {
      area: getUserSelect.area,
      coupon: getUserSelect.couponType,
      country: getUserSelect.country,
      items: transformProductInfo,
      payPrice: productPriceInfo.payPrice,
      payType: getUserSelect.payType,
      shipping: getUserSelect.shipping,
      store: getUserSelect.store,
      subTotal: productPriceInfo.totalPrice,
      shippingPrice: productPriceInfo.shippingFee,
    };

    localStorage.setItem('step1checkoutInfo', JSON.stringify(checkoutInfo));
  }
}
